var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"wJ25qjHw_XX3pQXTGSkoC"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

/* eslint-disable no-nested-ternary */
import * as Sentry from "@sentry/react";

// const history = createBrowserHistory();

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
	dsn: SENTRY_DSN,
	ignoreErrors: [
		"getReadModeConfig",
		"getReadModeExtract",
		"getReadModeRender",
	],
	// We recommend adjusting this value in production, or using tracesSampler
	// for finer control
	tracesSampleRate: 1.0,
	debug: false,
	environment: process.env.NEXT_PUBLIC_NODE_ENV === "production"
		? "production" : process.env.NEXT_PUBLIC_NODE_ENV === "development"
			? "development" : process.env.NEXT_PUBLIC_NODE_ENV === "canary"
				? "canary" : "local",
	// ...
	// Note: if you want to override the automatic release value, do not set a
	// `release` value here - use the environment variable `SENTRY_RELEASE`, so
	// that it will also get attached to your source maps
});
